import { CallingService } from '../calling.service';

export class ProgressiveController {

    constructor(private callingService: CallingService) {}

     // to pause the call
  pauseCall() {
    return this.callingService.pauseCall();
  }

  // to resume the call
  resumeCall() {
    
    return this.callingService.resumeCall();
  }

  // to stop the call
  stopCall() {
    return  this.callingService.stopCall();
  }
    
}